// URL do Gravatar a partir do e-mail (md5, retina 2x, d=404 para cair no
// fallback de iniciais quando não há avatar). Padrão herdado do TaskLab.
import { md5 } from './md5.js';

export function gravatarUrl(email: string, size = 32): string {
  const hash = md5(email.trim().toLowerCase());
  return `https://www.gravatar.com/avatar/${hash}?s=${size * 2}&d=404`;
}
